import { DatePicker as AntdDatePicker } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { formats } from '../../library/constants';
import dayjs from '../../library/utils/dayjs';

const DatePicker = ({ value = null, disabledBefore, disabledAfter , onChange, useHidden, ...otherProps }) => {

    const formattedDate = () => (value ? dayjs(value, formats.backendDateFormat) : value)
    const [val, setVal] = useState(formattedDate()?.format(formats.backendDateFormat))

    useEffect(() => {
        setVal(formattedDate()?.format(formats.backendDateFormat))
    }, [value])
    const extraProps = { ...otherProps }
    if (useHidden && extraProps.name) {
        delete extraProps.name
    }
    const parseDate = (dateString) => {
        return dayjs(dateString, formats.backendDateFormat);
      };
    
      const disableDate = (current) => {
        if (disabledAfter) {
          const afterDate = parseDate(disabledAfter);
          if (current && current > afterDate.endOf('day')) {
            return true;
          }
        }
        if (disabledBefore) {
          const beforeDate = parseDate(disabledBefore);
          if (current && current < beforeDate.startOf('day')) {
            return true;
          }
        }
        if (!disabledBefore && current && current < dayjs().startOf('day')) {
          return true;
        }
        return false;
      };

    return (
        <>
            <AntdDatePicker
                defaultValue={formattedDate()}
                onChange={(date) => {
                  const newDate = date?.format(formats.backendDateFormat) || null
                  setVal(newDate)
                  onChange && onChange(newDate)
                }}
                format={formats.frontendDateFormat}
                disabledDate={disableDate}
                {...extraProps}
            />
            {useHidden && <input type="hidden" name={otherProps.name} value={val} />}
        </>
    )
}

DatePicker.propTypes = {
    value: function (props, propName, componentName) {
        if (props[propName] && !/[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(props[propName])) {
            return new Error(
                `Invalid value ${props[propName]}  for prop ${propName} supplied to ${componentName}. Validation failed.`
            );
        }
    },
    useHidden: PropTypes.bool,
    onChange: PropTypes.func,
    disabledBefore: PropTypes.string,
    disabledAfter: PropTypes.string
}

export default DatePicker;
